export const apiGetVideoPlaybackInfo = (host, token, contentId) => {
  return fetch(`${host}/playback/videoPlaybackInfo/${contentId}?usePreAuth=true`, {
    headers: {
      Authorization: token
    }
  })
};

export const apiGetChannelPlaybackInfo = (host, token, channelId) => {
  return fetch(`${host}/playback/channelPlaybackInfo/${channelId}?usePreAuth=true`, {
    headers: {
      Authorization: token
    }
  })
};

export const apiGetVideoAttributes = (host, token, contentId) => {
  return fetch(`${host}/content/videos/${contentId}?include=show`, {
    headers: {
      Authorization: token
    }
  })
};

export const apiGetChannelAttributes = (host, token, channelId) => {
  return fetch(`${host}/content/channels/${channelId}`, {
    headers: {
      Authorization: token
    }
  })
};

export const apiGetConfig = (host, token, configId) => {
  return fetch(`${host}/cms/configs/${configId}`, {
    headers: {
      Authorization: token
    }
  })
};

export const apiReportPlayback = (host, token, method, streamType, contentId, position) => {
  if (typeof streamType === "string") {
    streamType = streamType.toLowerCase();
  }
  if ((streamType !== "buffered" && streamType !== "live") 
      || !contentId 
      || (streamType === "buffered" && isNaN(position))) {
    return Promise.reject();
  }
  if (method !== "POST" && method !== "PUT") {
    method = "POST";
  }
  const type = streamType === "buffered" ? "video" : "channel";

  return fetch(`${host}/playback/report/${type}/${contentId}${type === "video" ? `?position=${position * 1000}` : ''}`, {
    method,
    headers: {
      Authorization: token
    }
  })
};


// WEBPACK FOOTER //
// ./src/api/index.js